import * as MicrosoftSDK from "microsoft-cognitiveservices-speech-sdk";
import { speechConfig, azureWebSocketURL } from "../azureWebSocket";
import { logger } from "@tt-app/utils";
import { LOGGER_EVENTS, LOGGER_RESULT } from "@tt-app/constants";

export async function connectionCheck(payload: any) {
  const azure = new Promise<number>(function(resolve, reject) {
    try {
      if (!WebSocket.prototype.OPEN) {
        logger.logEvent(LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE, {
          ...payload,
          connectionResult: LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE.MeasureValue,
          error: { message: "WebSocket isn't available" }
        });
      }

      const ws = new WebSocket(azureWebSocketURL);

      ws.onopen = () => {
        ws.send("test");
      };

      ws.onmessage = () => {
        resolve(LOGGER_RESULT.SUCCESS);
        ws.close();
      };

      ws.onerror = err => {
        logger.logEvent(LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE, {
          ...payload,
          connectionResult: LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE.MeasureValue,
          error: { message: "Websocket isn't available" }
        });
      };

      ws.onclose = () => {
        const recognizerConfig: MicrosoftSDK.SpeechRecognizer = new MicrosoftSDK.SpeechRecognizer(
          speechConfig
        );

        let connected = false;
        const connection: MicrosoftSDK.Connection = MicrosoftSDK.Connection.fromRecognizer(
          recognizerConfig
        );

        connection.openConnection();

        connection.connected = () => {
          connected = true;
        };

        setTimeout(function() {
          connection.closeConnection();
        });

        connection.disconnected = () => {
          if (connected) {
            resolve(LOGGER_RESULT.SUCCESS);
          } else {
            resolve(LOGGER_RESULT.FAILURE);
          }
        };
      };
    } catch (e) {
      console.log("error: ", e);
      logger.logEvent(LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE, {
        ...payload,
        connectionResult: LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE.MeasureValue,
        error: { message: "WebSocket isn't available" }
      });
    }
  });

  const startTime = performance.now();
  const azureCheckResult = await azure;
  const endTime = performance.now();
  // performance.now() return ms, so to convert: 1sec = 1000ms
  const duration = (endTime - startTime) / 1000;

  if (azureCheckResult == LOGGER_RESULT.SUCCESS) {
    // can connect to websocket and azure sdk
    // communication mode can be changed to turbo
    logger.logEvent(LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.SUCCESS, {
      ...payload,
      connectionResult: LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.SUCCESS.MeasureValue,
      duration
    });
  } else {
    // must fall back to basic
    logger.logEvent(LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE, {
      ...payload,
      connectionResult: LOGGER_EVENTS.APPLICATION.CONNECTION_METHOD_CHECK.FAILURE.MeasureValue,
      duration
    });
  }
}
